const getTotals = (invoice, modules) => {
  const subTotal = () => {
    if (!Array.isArray(modules)) {
      return 0;
    }
    return modules.reduce((memo, item) => {
      return memo + item.quantity * item.price * invoice.license_term;
    }, 0);
  };

  const taxes = () => {
    if (!invoice.tax_pct) {
      return 0;
    }
    //const myTotal = subTotal() * invoice.license_term;
    const mytaxes = roundToDecimal(subTotal() * (invoice.tax_pct ? invoice.tax_pct : 0), 2);
    return mytaxes;
  };

  const localTaxes = () => {
    if (invoice.local_tax_pct === 0.0) {
      return 0;
    }

    if (invoice.local_tax_pct && invoice.local_tax_pct === 0) return 0;
    const local = roundToDecimal((subTotal() * invoice.local_tax_pct), 2);
    const tax = roundToDecimal((subTotal() * invoice.tax_pct), 2);
    const totalTax = roundToDecimal((subTotal() * (invoice.local_tax_pct + invoice.tax_pct)), 2);

    if (totalTax === tax + local) {
      return local;
    }
    return totalTax - tax;

    //const myTotal = subTotal() * invoice.license_term;
    // const myLocalTaxes = subTotal() * (invoice.local_tax_pct ? invoice.local_tax_pct : 0);
    // return myLocalTaxes;
  };

  const total = () => {
    if (!invoice) {
      return 0;
    }
    return subTotal() + taxes() + localTaxes();
  };

  return { subTotal: subTotal(), taxes: taxes(), total: total(), localTaxes: localTaxes() };
};

const getSitesTotals = (invoice, modules, sites) => {
  const siteSubTotal = (siteOrder) => {
    if (!siteOrder || !siteOrder.addOns ) return 0;
    const addOnTotal = siteOrder.addOns.reduce((memo, item) => {
      return memo + item.price;
    }, 0);
    
    return addOnTotal + siteOrder.price;
  }

  const sitesTotal = () => {
    let total = 0;
    if (sites && sites.length > 0) {
      sites.forEach(order => {
        total += siteSubTotal(order);
      });
      return total * (+invoice.license_term);
    }
    return total;
  }

  /**
   * 
   * @returns {number} state tax amount for the invoice 
   */
  const sitesTax = () => {
    if (!invoice.tax_pct) return 0;
    return roundToDecimal((sitesTotal() * invoice.tax_pct), 2);
  }
  /**if state tax and local tax can be added up to total tax (1 or 2 cents diff),
   * keep state tax as it is,
   * local tax equals total tax - state tax
    */
  const sitesLocalTax = () => {
    if (invoice.local_tax_pct && invoice.local_tax_pct === 0) return 0;
    const local = roundToDecimal((sitesTotal() * invoice.local_tax_pct), 2);
    const tax = roundToDecimal((sitesTotal() * invoice.tax_pct), 2);
    const totalTax = roundToDecimal((sitesTotal() * (invoice.local_tax_pct + invoice.tax_pct)), 2);

    if (totalTax === tax + local) {
      return local;
    }
    return totalTax - tax;
  }
  const sitesTotalTax = () => {
    return roundToDecimal((sitesTotal() * (invoice.tax_pct + invoice.local_tax_pct)), 2);
  }

  const sitesSum = () => {
    if (sitesLocalTax() === 0) {
      return roundToDecimal((sitesTotal() + sitesTax()), 2);
    }
    else {

      if (sitesTotalTax() === sitesTax() + sitesLocalTax()) {
        return sitesTotal() + sitesTax() + sitesLocalTax();
      }
      else {
        return sitesTotal() + sitesTax() + (sitesTotalTax() - sitesTax());
      }

    }

  }


  return { sitesTotal: sitesTotal(), siteSubTotal: siteSubTotal(), sitesTax: sitesTax(), sitesSum: sitesSum(), sitesLocalTax: sitesLocalTax() };
};

/**to fix round issue in toFixed built-in function */
const roundToDecimal = (number, decimalPlaces) => {
  const factor = 10 ** decimalPlaces;
  return Math.round(number * factor) / factor;
}

export { getTotals, getSitesTotals };
